import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import FeatureConfigurationModel, { SupportedFeatures } from "../model/FeatureConfiguration";

const FeatureConfigurationApiService = async (featureName: SupportedFeatures): Promise<FeatureConfigurationModel> => {
  const url = `/employer_features_config/feature_configuration/?feature_name=${featureName}`;
  const { data } = await axios.get(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useFeatureConfigurationApiService = (featureName: SupportedFeatures) =>
  useQuery<Promise<FeatureConfigurationModel>, AxiosError, FeatureConfigurationModel>(
    ["FeatureConfigurationApiService", featureName],
    () => FeatureConfigurationApiService(featureName)
  );

export default useFeatureConfigurationApiService;
